export default "__VITE_PUBLIC_ASSET__51df1b54__"